import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { fetchApi } from '../../services/api';

export default function facilityBreadcrumb<T extends RouteComponentProps>(WrappedComponent: React.ComponentType<T>, options = {}) {

    type State = {
        facilityName: string;
    }

    type Props = RouteComponentProps<{ facilityId: string }>;

    return class extends React.Component<Props, State> {

        constructor(props: Props){
            super(props);

            this.state = {
                facilityName: ''
            }

            this.fetchFacilityName = this.fetchFacilityName.bind(this);
        }

        componentDidMount() {
            this.fetchFacilityName(parseInt(this.props.match.params.facilityId));
        }

        componentWillReceiveProps(nextProps: Props) {
            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;

            if (currentPage !== nextPage) {
                this.fetchFacilityName(parseInt(nextProps.match.params.facilityId));
            }
        }

        render() {
            return <React.Fragment>
                <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to='/facilities'>Facilities</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">{this.state.facilityName}</li>
                </ol>
                </nav>
                <WrappedComponent {...(this.props as T)} />
            </React.Fragment>
            ;
        }

        private fetchFacilityName(facilityId: number) {
            if (facilityId == 0) {
                this.setState({ facilityName: "New Facility" })
            } else {
                fetchApi(`/api/Breadcrumb/Facility/${facilityId}`)
                    .then((facilityName) => this.setState({ facilityName }))
            }
        };
    };
}
